import { getErrorSource } from "./hmiError";
import { ProductType } from "./machine";

describe("getErrorSource", () => {
    it("should return the correct error source", () => {
        const machines = [
            {
                productNo: "a",
                errorSources: ["MMC"]
            },
            {
                productNo: "b",
                errorSources: ["TruControl"]
            },
            {
                productNo: "c",
                errorSources: ["MMC", "TruControl"]
            }
        ] as unknown as ProductType[];
        expect(getErrorSource("123.123", "a", machines)).toBe("MMC");
        expect(getErrorSource("abc", "b", machines)).toBe("UNDEFINED");
        expect(getErrorSource("abC0.1234", "c", machines)).toBe("TruControl");
        expect(getErrorSource("123.1234", "c", machines)).toBe("MMC");
    });
});
